// src/components/features/Elevation/components/ElevationStep3Pergola.jsx
// Pergola — swipe-style selection (folder "10.Pergola" me "Radio" naam
// nahi tha, isliye ye ab Theme step jaisa swipe UI use karta hai —
// pehle ye radio-list style tha, ab convert kar diya gaya hai)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { PERGOLA_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep3Pergola(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="Pergola"
      subtitle="Swipe through pergola styles and pick what you like"
      items={PERGOLA_IMAGES}
      selectedFieldKey="elevationPergola"
      likedFieldKey="elevationLikedPergola"
    />
  );
}
